import {
    REQUEST_FAQ,
    RECEIVE_FAQ,
    ERROR_FAQ
} from '../types'
import {initialFetchState} from "../../constants/defaultValues"
import _cloneDeep from 'lodash/cloneDeep'

export default (state = {}, action = {}) => {
    const newState = _cloneDeep(state)

    switch(action.type) {
        case REQUEST_FAQ:
            newState[action.id] = {
                ...initialFetchState,
                data: {},
                isFetching: true
            }
            return newState
        case RECEIVE_FAQ:
            newState[action.id] = {
                ...newState[action.id],
                isFetching: false,
                data: action.payload,
                shouldReload: false,
                message: '',
                errors: {}
            }
            return newState
        case ERROR_FAQ:
            newState[action.id] = {
                ...newState[action.id],
                isFetching: false,
                data: {},
                message: action.errors.server || '',
                errors: action.errors
            }
            return newState
        default:
            return state
    }
}